import { AfterContentChecked, AfterContentInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { UsuarioService } from 'src/app/services/usuario.service';

@Component({
  selector: 'app-solicitar-pt',
  templateUrl: './solicitar-pt.component.html'
})
export class SolicitarPtComponent implements OnInit, AfterContentChecked, AfterContentInit {


  constructor(
    private activatedRouter: ActivatedRoute, 
    private usuarioService: UsuarioService,
    
    ) { }

  isNovoCadastro = true;
  hasParameter = false;
  autorizacoes: UsuarioAutorizacoes;
  

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('solicitar-pt');
  }

  ngOnInit() {
    this.setIsNovoCadastro();
  }

  

  ngAfterContentChecked(): void {
   this.setIsNovoCadastro();

  }

  private setIsNovoCadastro() {
     this.activatedRouter.children[0].url.subscribe((url) => {
       if (url[0]) {
        this.isNovoCadastro = url[0].path === 'cadastrar';
       }

    });

     this.activatedRouter.firstChild.params.subscribe((param) => { this.hasParameter = (param.id !== undefined  || param.id === ''); });
  }


}
